var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBriefcase2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6658 29.3333H21.3325C26.6925 29.3333 27.6525 27.1867 27.9325 24.5733L28.9325 13.9067C29.2925 10.6533 28.3591 8 22.6658 8H9.33245C3.63912 8 2.70578 10.6533 3.06578 13.9067L4.06578 24.5733C4.34578 27.1867 5.30578 29.3333 10.6658 29.3333Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 8.00033V6.93366C10.666 4.57366 10.666 2.66699 14.9327 2.66699H17.066C21.3327 2.66699 21.3327 4.57366 21.3327 6.93366V8.00033",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 17.3333V18.6667C18.6673 18.68 18.6673 18.68 18.6673 18.6933C18.6673 20.1467 18.654 21.3333 16.0007 21.3333C13.3607 21.3333 13.334 20.16 13.334 18.7067V17.3333C13.334 16 13.334 16 14.6673 16H17.334C18.6673 16 18.6673 16 18.6673 17.3333Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.866 14.667C25.786 16.907 22.266 18.2403 18.666 18.6937",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49414 15.0264C6.49414 17.0797 9.88081 18.3197 13.3341 18.7064",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBriefcase2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/briefcase2.5b3c9173.svg";
export { ForwardRef as ReactComponent };